const tabledeclaration = [
    {
        key: "business_code",
        name: "事業者コード",
        editable: false
    },
    {
        key: "business_name",
        name: "事業者名",
        editable: false
    },
    {
        key: "data_name",
        name: "データ名称",
        editable: false
    },
    {
        key: "item_name",
        name: "項目名",
        editable: false
    },
    {
        key: "ten_taxable_base",
        name: "10％分_課税売上_本体価額",
        editable: false
    },
    {
        key: "ten_taxable_consumption_tax",
        name: "10％分_課税売上_仮受消費税",
        editable: false
    },
    {
        key: "ten_taxable_included",
        name: "10％分_課税売上_税込価額",
        editable: false
    },
    {
        key: "ten_tax_free_base",
        name: "10％分_免税売上_本体価額",
        editable: false
    },
    {
        key: "ten_non_taxable_securities_base",
        name: "10％分_非課税売上_有価証券_本体価額",
        editable: false
    },
    {
        key: "ten_non_taxable_non_securities_base",
        name: "10％分_非課税売上_有価証券以外_本体価額",
        editable: false
    },
    {
        key: "ten_non_assets_base",
        name: "10％分_非課税資産の輸出等_本体価額",
        editable: false
    },
    {
        key: "ten_taxable_consider_base",
        name: "10％分_課税売上に係る対価の返還_本体価額",
        editable: false
    },
    {
        key: "ten_taxable_consider_consumption_tax",
        name: "10％分_課税売上に係る対価の返還_仮受消費税",
        editable: false
    },
    {
        key: "ten_taxable_consider_included",
        name: "10％分_課税売上に係る対価の返還_税込価額",
        editable: false
    },
    {
        key: "ten_tax_free_consider_base",
        name: "10％分_免税売上に係る対価の返還_本体価額",
        editable: false
    },
    {
        key: "ten_non_taxable_consider_base",
        name: "10％分_非課税売上に係る対価の返還_本体価額",
        editable: false
    },
    {
        key: "ten_non_assets_return_base",
        name: "10％分_非課税資産の輸出等の返還_本体価額",
        editable: false
    },
    {
        key: "ten_purchase_taxable_resp_base",
        name: "10％分_仕入_課税売上対応_本体価額",
        editable: false
    },
    {
        key: "ten_purchase_taxable_resp_body",
        name: "10％分_仕入_課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "ten_purchase_taxable_resp_included",
        name: "10％分_仕入_課税売上対応_税込価額",
        editable: false
    },
    {
        key: "ten_purchase_non_taxable_resp_base",
        name: "10％分_仕入_非課税売上対応_本体価額",
        editable: false
    },
    {
        key: "ten_purchase_non_taxable_resp_body",
        name: "10％分_仕入_非課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "ten_purchase_non_taxable_resp_included",
        name: "10％分_仕入_非課税売上対応_税込価額",
        editable: false
    },
    {
        key: "ten_purchase_common_resp_base",
        name: "10％分_仕入_共通売上対応_本体価額",
        editable: false
    },
    {
        key: "ten_purchase_common_resp_body",
        name: "10％分_仕入_共通売上対応_仮払消費税",
        editable: false
    },
    {
        key: "ten_purchase_common_resp_included",
        name: "10％分_仕入_共通売上対応_税込価額",
        editable: false
    },
    {
        key: "ten_import_taxable_resp_body",
        name: "10％分_輸入仕入_課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "ten_import_non_taxable_resp_body",
        name: "10％分_輸入仕入_非課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "ten_import_common_resp_body",
        name: "10％分_輸入仕入_共通売上対応_仮払消費税",
        editable: false
    },
    {
        key: "ten_import_local_body",
        name: "10％分_輸入仕入_地方消費税分_仮払消費税",
        editable: false
    },
    {
        key: "ten_return_taxable_resp_base",
        name: "10％分_仕入返還_課税売上対応_本体価額",
        editable: false
    },
    {
        key: "ten_return_taxable_resp_body",
        name: "10％分_仕入返還_課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "ten_return_taxable_resp_included",
        name: "10％分_仕入返還_課税売上対応_税込価額",
        editable: false
    },
    {
        key: "ten_return_non_taxable_resp_base",
        name: "10％分_仕入返還_非課税売上対応_本体価額",
        editable: false
    },
    {
        key: "ten_return_non_taxable_resp_body",
        name: "10％分_仕入返還_非課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "ten_return_non_taxable_resp_included",
        name: "10％分_仕入返還_非課税売上対応_税込価額",
        editable: false
    },
    {
        key: "ten_return_common_resp_base",
        name: "10％分_仕入返還_共通売上対応_本体価額",
        editable: false
    },
    {
        key: "ten_return_common_resp_body",
        name: "10％分_仕入返還_共通売上対応_仮払消費税",
        editable: false
    },
    {
        key: "ten_return_common_resp_included",
        name: "10％分_仕入返還_共通売上対応_税込価額",
        editable: false
    },
    {
        key: "ten_import_return_taxable_resp_body",
        name: "10％分_輸入仕入返還_課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "ten_import_return_non_taxable_resp_body",
        name: "10％分_輸入仕入返還_非課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "ten_import_return_common_resp_body",
        name: "10％分_輸入仕入返還_共通売上対応_仮払消費税",
        editable: false
    },
    {
        key: "ten_import_return_local_body",
        name: "10％分_輸入仕入返還_地方消費税分_仮払消費税",
        editable: false
    },
    {
        key: "ten_spec_purchase_taxable_resp_base",
        name: "10％分_特定仕入_課税売上対応_本体価額",
        editable: false
    },
    {
        key: "ten_spec_purchase_non_taxable_resp_base",
        name: "10％分_特定仕入_非課税売上対応_本体価額",
        editable: false
    },
    {
        key: "ten_spec_purchase_common_resp_base",
        name: "10％分_特定仕入_共通売上対応_本体価額",
        editable: false
    },
    {
        key: "ten_spec_return_taxable_resp_base",
        name: "10％分_特定仕入返還_課税売上対応_本体価額",
        editable: false
    },
    {
        key: "ten_spec_return_non_taxable_resp_base",
        name: "10％分_特定仕入返還_非課税売上対応_本体価額",
        editable: false
    },
    {
        key: "ten_spec_return_common_resp_base",
        name: "10％分_特定仕入返還_共通売上対応_本体価額",
        editable: false
    },
    {
        key: "ten_loan_base",
        name: "10％分_貸倒れ額_本体価額",
        editable: false
    },
    {
        key: "ten_loan_consumption_tax",
        name: "10％分_貸倒れ額_仮受消費税",
        editable: false
    },
    {
        key: "ten_loan_included",
        name: "10％分_貸倒れ額_税込価額",
        editable: false
    },
    {
        key: "ten_recovery_base",
        name: "10％分_貸倒れ回収金額_本体価額",
        editable: false
    },
    {
        key: "ten_recovery_consumption_tax",
        name: "10％分_貸倒れ回収金額_仮受消費税",
        editable: false
    },
    {
        key: "ten_recovery_included",
        name: "10％分_貸倒れ回収金額_税込価額",
        editable: false
    },
    {
        key: "eight_m_taxable_base",
        name: "軽8％分_課税売上_本体価額",
        editable: false
    },
    {
        key: "eight_m_taxable_consumption_tax",
        name: "軽8％分_課税売上_仮受消費税",
        editable: false
    },
    {
        key: "eight_m_taxable_included",
        name: "軽8％分_課税売上_税込価額",
        editable: false
    },
    {
        key: "eight_m_tax_free_base",
        name: "軽8％分_免税売上_本体価額",
        editable: false
    },
    {
        key: "eight_m_non_taxable_securities_base",
        name: "軽8％分_非課税売上_有価証券_本体価額",
        editable: false
    },
    {
        key: "eight_m_non_taxable_non_securities_base",
        name: "軽8％分_非課税売上_有価証券以外_本体価額",
        editable: false
    },
    {
        key: "eight_m_non_assets_base",
        name: "軽8％分_非課税資産の輸出等_本体価額",
        editable: false
    },
    {
        key: "eight_m_taxable_consider_base",
        name: "軽8％分_課税売上に係る対価の返還_本体価額",
        editable: false
    },
    {
        key: "eight_m_taxable_consider_consumption_tax",
        name: "軽8％分_課税売上に係る対価の返還_仮受消費税",
        editable: false
    },
    {
        key: "eight_m_taxable_consider_included",
        name: "軽8％分_課税売上に係る対価の返還_税込価額",
        editable: false
    },
    {
        key: "eight_m_tax_free_consider_base",
        name: "軽8％分_免税売上に係る対価の返還_本体価額",
        editable: false
    },
    {
        key: "eight_m_non_taxable_consider_base",
        name: "軽8％分_非課税売上に係る対価の返還_本体価額",
        editable: false
    },
    {
        key: "eight_m_non_assets_return_base",
        name: "軽8％分_非課税資産の輸出等の返還_本体価額",
        editable: false
    },
    {
        key: "eight_m_purchase_taxable_resp_base",
        name: "軽8％分_仕入_課税売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_m_purchase_taxable_resp_body",
        name: "軽8％分_仕入_課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_m_purchase_taxable_resp_included",
        name: "軽8％分_仕入_課税売上対応_税込価額",
        editable: false
    },
    {
        key: "eight_m_purchase_non_taxable_resp_base",
        name: "軽8％分_仕入_非課税売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_m_purchase_non_taxable_resp_body",
        name: "軽8％分_仕入_非課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_m_purchase_non_taxable_resp_included",
        name: "軽8％分_仕入_非課税売上対応_税込価額",
        editable: false
    },
    {
        key: "eight_m_purchase_common_resp_base",
        name: "軽8％分_仕入_共通売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_m_purchase_common_resp_body",
        name: "軽8％分_仕入_共通売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_m_purchase_common_resp_included",
        name: "軽8％分_仕入_共通売上対応_税込価額",
        editable: false
    },
    {
        key: "eight_m_import_taxable_resp_body",
        name: "軽8％分_輸入仕入_課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_m_import_non_taxable_resp_body",
        name: "軽8％分_輸入仕入_非課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_m_import_common_resp_body",
        name: "軽8％分_輸入仕入_共通売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_m_import_local_body",
        name: "軽8％分_輸入仕入_地方消費税分_仮払消費税",
        editable: false
    },
    {
        key: "eight_m_return_taxable_resp_base",
        name: "軽8％分_仕入返還_課税売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_m_return_taxable_resp_body",
        name: "軽8％分_仕入返還_課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_m_return_taxable_resp_included",
        name: "軽8％分_仕入返還_課税売上対応_税込価額",
        editable: false
    },
    {
        key: "eight_m_return_non_taxable_resp_base",
        name: "軽8％分_仕入返還_非課税売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_m_return_non_taxable_resp_body",
        name: "軽8％分_仕入返還_非課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_m_return_non_taxable_resp_included",
        name: "軽8％分_仕入返還_非課税売上対応_税込価額",
        editable: false
    },
    {
        key: "eight_m_return_common_resp_base",
        name: "軽8％分_仕入返還_共通売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_m_return_common_resp_body",
        name: "軽8％分_仕入返還_共通売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_m_return_common_resp_included",
        name: "軽8％分_仕入返還_共通売上対応_税込価額",
        editable: false
    },
    {
        key: "eight_m_import_return_taxable_resp_body",
        name: "軽8％分_輸入仕入返還_課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_m_import_return_non_taxable_resp_body",
        name: "軽8％分_輸入仕入返還_非課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_m_import_return_common_resp_body",
        name: "軽8％分_輸入仕入返還_共通売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_m_import_return_local_body",
        name: "軽8％分_輸入仕入返還_地方消費税分_仮払消費税",
        editable: false
    },
    {
        key: "eight_m_spec_purchase_taxable_resp_base",
        name: "軽8％分_特定仕入_課税売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_m_spec_purchase_non_taxable_resp_base",
        name: "軽8％分_特定仕入_非課税売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_m_spec_purchase_common_resp_base",
        name: "軽8％分_特定仕入_共通売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_m_spec_return_taxable_resp_base",
        name: "軽8％分_特定仕入返還_課税売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_m_spec_return_non_taxable_resp_base",
        name: "軽8％分_特定仕入返還_非課税売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_m_spec_return_common_resp_base",
        name: "軽8％分_特定仕入返還_共通売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_m_loan_base",
        name: "軽8％分_貸倒れ額_本体価額",
        editable: false
    },
    {
        key: "eight_m_loan_consumption_tax",
        name: "軽8％分_貸倒れ額_仮受消費税",
        editable: false
    },
    {
        key: "eight_m_loan_included",
        name: "軽8％分_貸倒れ額_税込価額",
        editable: false
    },
    {
        key: "eight_m_recovery_base",
        name: "軽8％分_貸倒れ回収金額_本体価額",
        editable: false
    },
    {
        key: "eight_m_recovery_consumption_tax",
        name: "軽8％分_貸倒れ回収金額_仮受消費税",
        editable: false
    },
    {
        key: "eight_m_recovery_included",
        name: "軽8％分_貸倒れ回収金額_税込価額",
        editable: false
    },
    {
        key: "eight_taxable_base",
        name: "8％分_課税売上_本体価額",
        editable: false
    },
    {
        key: "eight_taxable_consumption_tax",
        name: "8％分_課税売上_仮受消費税",
        editable: false
    },
    {
        key: "eight_taxable_included",
        name: "8％分_課税売上_税込価額",
        editable: false
    },
    {
        key: "eight_tax_free_base",
        name: "8％分_免税売上_本体価額",
        editable: false
    },
    {
        key: "eight_non_taxable_securities_base",
        name: "8％分_非課税売上_有価証券_本体価額",
        editable: false
    },
    {
        key: "eight_non_taxable_non_securities_base",
        name: "8％分_非課税売上_有価証券以外_本体価額",
        editable: false
    },
    {
        key: "eight_non_assets_base",
        name: "8％分_非課税資産の輸出等_本体価額",
        editable: false
    },
    {
        key: "eight_taxable_consider_base",
        name: "8％分_課税売上に係る対価の返還_本体価額",
        editable: false
    },
    {
        key: "eight_taxable_consider_consumption_tax",
        name: "8％分_課税売上に係る対価の返還_仮受消費税",
        editable: false
    },
    {
        key: "eight_taxable_consider_included",
        name: "8％分_課税売上に係る対価の返還_税込価額",
        editable: false
    },
    {
        key: "eight_tax_free_consider_base",
        name: "8％分_免税売上に係る対価の返還_本体価額",
        editable: false
    },
    {
        key: "eight_non_taxable_consider_base",
        name: "8％分_非課税売上に係る対価の返還_本体価額",
        editable: false
    },
    {
        key: "eight_non_assets_return_base",
        name: "8％分_非課税資産の輸出等の返還_本体価額",
        editable: false
    },
    {
        key: "eight_purchase_taxable_resp_base",
        name: "8％分_仕入_課税売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_purchase_taxable_resp_body",
        name: "8％分_仕入_課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_purchase_taxable_resp_included",
        name: "8％分_仕入_課税売上対応_税込価額",
        editable: false
    },
    {
        key: "eight_purchase_non_taxable_resp_base",
        name: "8％分_仕入_非課税売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_purchase_non_taxable_resp_body",
        name: "8％分_仕入_非課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_purchase_non_taxable_resp_included",
        name: "8％分_仕入_非課税売上対応_税込価額",
        editable: false
    },
    {
        key: "eight_purchase_common_resp_base",
        name: "8％分_仕入_共通売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_purchase_common_resp_body",
        name: "8％分_仕入_共通売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_purchase_common_resp_included",
        name: "8％分_仕入_共通売上対応_税込価額",
        editable: false
    },
    {
        key: "eight_import_taxable_resp_body",
        name: "8％分_輸入仕入_課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_import_non_taxable_resp_body",
        name: "8％分_輸入仕入_非課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_import_common_resp_body",
        name: "8％分_輸入仕入_共通売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_import_local_body",
        name: "8％分_輸入仕入_地方消費税分_仮払消費税",
        editable: false
    },
    {
        key: "eight_return_taxable_resp_base",
        name: "8％分_仕入返還_課税売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_return_taxable_resp_body",
        name: "8％分_仕入返還_課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_return_taxable_resp_included",
        name: "8％分_仕入返還_課税売上対応_税込価額",
        editable: false
    },
    {
        key: "eight_return_non_taxable_resp_base",
        name: "8％分_仕入返還_非課税売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_return_non_taxable_resp_body",
        name: "8％分_仕入返還_非課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_return_non_taxable_resp_included",
        name: "8％分_仕入返還_非課税売上対応_税込価額",
        editable: false
    },
    {
        key: "eight_return_common_resp_base",
        name: "8％分_仕入返還_共通売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_return_common_resp_body",
        name: "8％分_仕入返還_共通売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_return_common_resp_included",
        name: "8％分_仕入返還_共通売上対応_税込価額",
        editable: false
    },
    {
        key: "eight_import_return_taxable_resp_body",
        name: "8％分_輸入仕入返還_課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_import_return_non_taxable_resp_body",
        name: "8％分_輸入仕入返還_非課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_import_return_common_resp_body",
        name: "8％分_輸入仕入返還_共通売上対応_仮払消費税",
        editable: false
    },
    {
        key: "eight_import_return_local_body",
        name: "8％分_輸入仕入返還_地方消費税分_仮払消費税",
        editable: false
    },
    {
        key: "eight_spec_purchase_taxable_resp_base",
        name: "8％分_特定仕入_課税売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_spec_purchase_non_taxable_resp_base",
        name: "8％分_特定仕入_非課税売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_spec_purchase_common_resp_base",
        name: "8％分_特定仕入_共通売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_spec_return_taxable_resp_base",
        name: "8％分_特定仕入返還_課税売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_spec_return_non_taxable_resp_base",
        name: "8％分_特定仕入返還_非課税売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_spec_return_common_resp_base",
        name: "8％分_特定仕入返還_共通売上対応_本体価額",
        editable: false
    },
    {
        key: "eight_loan_base",
        name: "8％分_貸倒れ額_本体価額",
        editable: false
    },
    {
        key: "eight_loan_consumption_tax",
        name: "8％分_貸倒れ額_仮受消費税",
        editable: false
    },
    {
        key: "eight_loan_included",
        name: "8％分_貸倒れ額_税込価額",
        editable: false
    },
    {
        key: "eight_recovery_base",
        name: "8％分_貸倒れ回収金額_本体価額",
        editable: false
    },
    {
        key: "eight_recovery_consumption_tax",
        name: "8％分_貸倒れ回収金額_仮受消費税",
        editable: false
    },
    {
        key: "eight_recovery_included",
        name: "8％分_貸倒れ回収金額_税込価額",
        editable: false
    },
    {
        key: "five_taxable_base",
        name: "5％分_課税売上_本体価額",
        editable: false
    },
    {
        key: "five_taxable_consumption_tax",
        name: "5％分_課税売上_仮受消費税",
        editable: false
    },
    {
        key: "five_taxable_included",
        name: "5％分_課税売上_税込価額",
        editable: false
    },
    {
        key: "five_tax_free_base",
        name: "5％分_免税売上_本体価額",
        editable: false
    },
    {
        key: "five_non_taxable_securities_base",
        name: "5％分_非課税売上_有価証券_本体価額",
        editable: false
    },
    {
        key: "five_non_taxable_non_securities_base",
        name: "5％分_非課税売上_有価証券以外_本体価額",
        editable: false
    },
    {
        key: "five_non_assets_base",
        name: "5％分_非課税資産の輸出等_本体価額",
        editable: false
    },
    {
        key: "five_taxable_consider_base",
        name: "5％分_課税売上に係る対価の返還_本体価額",
        editable: false
    },
    {
        key: "five_taxable_consider_consumption_tax",
        name: "5％分_課税売上に係る対価の返還_仮受消費税",
        editable: false
    },
    {
        key: "five_taxable_consider_included",
        name: "5％分_課税売上に係る対価の返還_税込価額",
        editable: false
    },
    {
        key: "five_tax_free_consider_base",
        name: "5％分_免税売上に係る対価の返還_本体価額",
        editable: false
    },
    {
        key: "five_non_taxable_consider_base",
        name: "5％分_非課税売上に係る対価の返還_本体価額",
        editable: false
    },
    {
        key: "five_non_assets_return_base",
        name: "5％分_非課税資産の輸出等の返還_本体価額",
        editable: false
    },
    {
        key: "five_purchase_taxable_resp_base",
        name: "5％分_仕入_課税売上対応_本体価額",
        editable: false
    },
    {
        key: "five_purchase_taxable_resp_body",
        name: "5％分_仕入_課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "five_purchase_taxable_resp_included",
        name: "5％分_仕入_課税売上対応_税込価額",
        editable: false
    },
    {
        key: "five_purchase_non_taxable_resp_base",
        name: "5％分_仕入_非課税売上対応_本体価額",
        editable: false
    },
    {
        key: "five_purchase_non_taxable_resp_body",
        name: "5％分_仕入_非課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "five_purchase_non_taxable_resp_included",
        name: "5％分_仕入_非課税売上対応_税込価額",
        editable: false
    },
    {
        key: "five_purchase_common_resp_base",
        name: "5％分_仕入_共通売上対応_本体価額",
        editable: false
    },
    {
        key: "five_purchase_common_resp_body",
        name: "5％分_仕入_共通売上対応_仮払消費税",
        editable: false
    },
    {
        key: "five_purchase_common_resp_included",
        name: "5％分_仕入_共通売上対応_税込価額",
        editable: false
    },
    {
        key: "five_import_taxable_resp_body",
        name: "5％分_輸入仕入_課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "five_import_non_taxable_resp_body",
        name: "5％分_輸入仕入_非課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "five_import_common_resp_body",
        name: "5％分_輸入仕入_共通売上対応_仮払消費税",
        editable: false
    },
    {
        key: "five_import_local_body",
        name: "5％分_輸入仕入_地方消費税分_仮払消費税",
        editable: false
    },
    {
        key: "five_return_taxable_resp_base",
        name: "5％分_仕入返還_課税売上対応_本体価額",
        editable: false
    },
    {
        key: "five_return_taxable_resp_body",
        name: "5％分_仕入返還_課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "five_return_taxable_resp_included",
        name: "5％分_仕入返還_課税売上対応_税込価額",
        editable: false
    },
    {
        key: "five_return_non_taxable_resp_base",
        name: "5％分_仕入返還_非課税売上対応_本体価額",
        editable: false
    },
    {
        key: "five_return_non_taxable_resp_body",
        name: "5％分_仕入返還_非課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "five_return_non_taxable_resp_included",
        name: "5％分_仕入返還_非課税売上対応_税込価額",
        editable: false
    },
    {
        key: "five_return_common_resp_base",
        name: "5％分_仕入返還_共通売上対応_本体価額",
        editable: false
    },
    {
        key: "five_return_common_resp_body",
        name: "5％分_仕入返還_共通売上対応_仮払消費税",
        editable: false
    },
    {
        key: "five_return_common_resp_included",
        name: "5％分_仕入返還_共通売上対応_税込価額",
        editable: false
    },
    {
        key: "five_import_return_taxable_resp_body",
        name: "5％分_輸入仕入返還_課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "five_import_return_non_taxable_resp_body",
        name: "5％分_輸入仕入返還_非課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "five_import_return_common_resp_body",
        name: "5％分_輸入仕入返還_共通売上対応_仮払消費税",
        editable: false
    },
    {
        key: "five_import_return_local_body",
        name: "5％分_輸入仕入返還_地方消費税分_仮払消費税",
        editable: false
    },
    {
        key: "five_spec_purchase_taxable_resp_base",
        name: "5％分_特定仕入_課税売上対応_本体価額",
        editable: false
    },
    {
        key: "five_spec_purchase_non_taxable_resp_base",
        name: "5％分_特定仕入_非課税売上対応_本体価額",
        editable: false
    },
    {
        key: "five_spec_purchase_common_resp_base",
        name: "5％分_特定仕入_共通売上対応_本体価額",
        editable: false
    },
    {
        key: "five_spec_return_taxable_resp_base",
        name: "5％分_特定仕入返還_課税売上対応_本体価額",
        editable: false
    },
    {
        key: "five_spec_return_non_taxable_resp_base",
        name: "5％分_特定仕入返還_非課税売上対応_本体価額",
        editable: false
    },
    {
        key: "five_spec_return_common_resp_base",
        name: "5％分_特定仕入返還_共通売上対応_本体価額",
        editable: false
    },
    {
        key: "five_loan_base",
        name: "5％分_貸倒れ額_本体価額",
        editable: false
    },
    {
        key: "five_loan_consumption_tax",
        name: "5％分_貸倒れ額_仮受消費税",
        editable: false
    },
    {
        key: "five_loan_included",
        name: "5％分_貸倒れ額_税込価額",
        editable: false
    },
    {
        key: "five_recovery_base",
        name: "5％分_貸倒れ回収金額_本体価額",
        editable: false
    },
    {
        key: "five_recovery_consumption_tax",
        name: "5％分_貸倒れ回収金額_仮受消費税",
        editable: false
    },
    {
        key: "five_recovery_included",
        name: "5％分_貸倒れ回収金額_税込価額",
        editable: false
    },
    {
        key: "three_taxable_base",
        name: "3％分_課税売上_本体価額",
        editable: false
    },
    {
        key: "three_taxable_consumption_tax",
        name: "3％分_課税売上_仮受消費税",
        editable: false
    },
    {
        key: "three_taxable_included",
        name: "3％分_課税売上_税込価額",
        editable: false
    },
    {
        key: "three_tax_free_base",
        name: "3％分_免税売上_本体価額",
        editable: false
    },
    {
        key: "three_non_taxable_securities_base",
        name: "3％分_非課税売上_有価証券_本体価額",
        editable: false
    },
    {
        key: "three_non_taxable_non_securities_base",
        name: "3％分_非課税売上_有価証券以外_本体価額",
        editable: false
    },
    {
        key: "three_non_assets_base",
        name: "3％分_非課税資産の輸出等_本体価額",
        editable: false
    },
    {
        key: "three_taxable_consider_base",
        name: "3％分_課税売上に係る対価の返還_本体価額",
        editable: false
    },
    {
        key: "three_taxable_consider_consumption_tax",
        name: "3％分_課税売上に係る対価の返還_仮受消費税",
        editable: false
    },
    {
        key: "three_taxable_consider_included",
        name: "3％分_課税売上に係る対価の返還_税込価額",
        editable: false
    },
    {
        key: "three_tax_free_consider_base",
        name: "3％分_免税売上に係る対価の返還_本体価額",
        editable: false
    },
    {
        key: "three_non_taxable_consider_base",
        name: "3％分_非課税売上に係る対価の返還_本体価額",
        editable: false
    },
    {
        key: "three_non_assets_return_base",
        name: "3％分_非課税資産の輸出等の返還_本体価額",
        editable: false
    },
    {
        key: "three_purchase_taxable_resp_base",
        name: "3％分_仕入_課税売上対応_本体価額",
        editable: false
    },
    {
        key: "three_purchase_taxable_resp_body",
        name: "3％分_仕入_課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "three_purchase_taxable_resp_included",
        name: "3％分_仕入_課税売上対応_税込価額",
        editable: false
    },
    {
        key: "three_purchase_non_taxable_resp_base",
        name: "3％分_仕入_非課税売上対応_本体価額",
        editable: false
    },
    {
        key: "three_purchase_non_taxable_resp_body",
        name: "3％分_仕入_非課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "three_purchase_non_taxable_resp_included",
        name: "3％分_仕入_非課税売上対応_税込価額",
        editable: false
    },
    {
        key: "three_purchase_common_resp_base",
        name: "3％分_仕入_共通売上対応_本体価額",
        editable: false
    },
    {
        key: "three_purchase_common_resp_body",
        name: "3％分_仕入_共通売上対応_仮払消費税",
        editable: false
    },
    {
        key: "three_purchase_common_resp_included",
        name: "3％分_仕入_共通売上対応_税込価額",
        editable: false
    },
    {
        key: "three_import_taxable_resp_body",
        name: "3％分_輸入仕入_課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "three_import_non_taxable_resp_body",
        name: "3％分_輸入仕入_非課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "three_import_common_resp_body",
        name: "3％分_輸入仕入_共通売上対応_仮払消費税",
        editable: false
    },
    {
        key: "three_import_local_body",
        name: "3％分_輸入仕入_地方消費税分_仮払消費税",
        editable: false
    },
    {
        key: "three_return_taxable_resp_base",
        name: "3％分_仕入返還_課税売上対応_本体価額",
        editable: false
    },
    {
        key: "three_return_taxable_resp_body",
        name: "3％分_仕入返還_課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "three_return_taxable_resp_included",
        name: "3％分_仕入返還_課税売上対応_税込価額",
        editable: false
    },
    {
        key: "three_return_non_taxable_resp_base",
        name: "3％分_仕入返還_非課税売上対応_本体価額",
        editable: false
    },
    {
        key: "three_return_non_taxable_resp_body",
        name: "3％分_仕入返還_非課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "three_return_non_taxable_resp_included",
        name: "3％分_仕入返還_非課税売上対応_税込価額",
        editable: false
    },
    {
        key: "three_return_common_resp_base",
        name: "3％分_仕入返還_共通売上対応_本体価額",
        editable: false
    },
    {
        key: "three_return_common_resp_body",
        name: "3％分_仕入返還_共通売上対応_仮払消費税",
        editable: false
    },
    {
        key: "three_return_common_resp_included",
        name: "3％分_仕入返還_共通売上対応_税込価額",
        editable: false
    },
    {
        key: "three_import_return_taxable_resp_body",
        name: "3％分_輸入仕入返還_課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "three_import_return_non_taxable_resp_body",
        name: "3％分_輸入仕入返還_非課税売上対応_仮払消費税",
        editable: false
    },
    {
        key: "three_import_return_common_resp_body",
        name: "3％分_輸入仕入返還_共通売上対応_仮払消費税",
        editable: false
    },
    {
        key: "three_import_return_local_body",
        name: "3％分_輸入仕入返還_地方消費税分_仮払消費税",
        editable: false
    },
    {
        key: "three_spec_purchase_taxable_resp_base",
        name: "3％分_特定仕入_課税売上対応_本体価額",
        editable: false
    },
    {
        key: "three_spec_purchase_non_taxable_resp_base",
        name: "3％分_特定仕入_非課税売上対応_本体価額",
        editable: false
    },
    {
        key: "three_spec_purchase_common_resp_base",
        name: "3％分_特定仕入_共通売上対応_本体価額",
        editable: false
    },
    {
        key: "three_spec_return_taxable_resp_base",
        name: "3％分_特定仕入返還_課税売上対応_本体価額",
        editable: false
    },
    {
        key: "three_spec_return_non_taxable_resp_base",
        name: "3％分_特定仕入返還_非課税売上対応_本体価額",
        editable: false
    },
    {
        key: "three_spec_return_common_resp_base",
        name: "3％分_特定仕入返還_共通売上対応_本体価額",
        editable: false
    },
    {
        key: "three_loan_base",
        name: "3％分_貸倒れ額_本体価額",
        editable: false
    },
    {
        key: "three_loan_consumption_tax",
        name: "3％分_貸倒れ額_仮受消費税",
        editable: false
    },
    {
        key: "three_loan_included",
        name: "3％分_貸倒れ額_税込価額",
        editable: false
    },
    {
        key: "three_recovery_base",
        name: "3％分_貸倒れ回収金額_本体価額",
        editable: false
    },
    {
        key: "three_recovery_consumption_tax",
        name: "3％分_貸倒れ回収金額_仮受消費税",
        editable: false
    },
    {
        key: "three_recovery_included",
        name: "3％分_貸倒れ回収金額_税込価額",
        editable: false
    },
    {
        key: "business_code_2",
        name: "事業者コード",
        editable: false
    },
    {
        key: "business_name_2",
        name: "事業者名",
        editable: false
    },
    {
        key: "data_name_2",
        name: "データ名称",
        editable: false
    },
    {
        key: "item_name_2",
        name: "項目名",
        editable: false
    },
    {
        key: "sales_calc_sel",
        name: "売上計算選択",
        editable: false
    },
    {
        key: "purchase_calc_sel",
        name: "仕入計算選択",
        editable: false
    },
    {
        key: "submission_date_name",
        name: "提出年月日_元号",
        editable: false
    },
    {
        key: "submission_date_year",
        name: "提出年月日_年",
        editable: false
    },
    {
        key: "submission_date_month",
        name: "提出年月日_月",
        editable: false
    },
    {
        key: "submission_date_day",
        name: "提出年月日_日",
        editable: false
    },
    {
        key: "interim_tax_paid",
        name: "中間納付税額",
        editable: false
    },
    {
        key: "interim_tax_discount",
        name: "中間納付譲渡割額",
        editable: false
    },
    {
        key: "apply_installment_criteria",
        name: "割賦基準の適用",
        editable: false
    },
    {
        key: "apply_deferred_payment_std",
        name: "延払基準等の適用",
        editable: false
    },
    {
        key: "apply_construction_progress_std",
        name: "工事進行基準の適用",
        editable: false
    },
    {
        key: "apply_cash_accounting",
        name: "現金主義会計の適用",
        editable: false
    },
    {
        key: "special_tax_amount",
        name: "課税標準額に係る消費税額の特例",
        editable: false
    },
    {
        key: "baseline_tax",
        name: "基準期間の課税売上高",
        editable: false
    },
    {
        key: "rules_30_category",
        name: "税理士法30条の書面提出有_該当区分",
        editable: false
    },
    {
        key: "rules_33_2_category",
        name: "税理士法33条の2の書面提出有_該当区分",
        editable: false
    },
    {
        key: "business_code_3",
        name: "事業者コード",
        editable: false
    },
    {
        key: "business_name_3",
        name: "事業者名",
        editable: false
    },
    {
        key: "data_name_3",
        name: "データ名称",
        editable: false
    },
    {
        key: "item_name_3",
        name: "項目名",
        editable: false
    },
    {
        key: "duty_free_category",
        name: "輸出等の免税取引の割合が高い_該当区分",
        editable: false
    },
    {
        key: "capital_applicable_category",
        name: "設備投資_該当区分",
        editable: false
    },
    {
        key: "other_applicable_category",
        name: "その他_該当区分",
        editable: false
    },
    {
        key: "other_reasons_upper",
        name: "その他の理由_上段",
        editable: false
    },
    {
        key: "other_reasons_lower",
        name: "その他の理由_下段",
        editable: false
    },
    {
        key: "trans_method_category",
        name: "取引金額等_経理方式区分",
        editable: false
    },
    {
        key: "financial_inst_name",
        name: "金融機関名",
        editable: false
    },
    {
        key: "financial_inst_type",
        name: "金融機関種類",
        editable: false
    },
    {
        key: "branch_name",
        name: "本支店名",
        editable: false
    },
    {
        key: "branch_category",
        name: "本支店区分",
        editable: false
    },
    {
        key: "deposit_category",
        name: "預金区分",
        editable: false
    },
    {
        key: "deposit_account",
        name: "預金口座番号",
        editable: false
    },
    {
        key: "name",
        name: "氏名_名称",
        editable: false
    },
    {
        key: "address",
        name: "住所_所在地",
        editable: false
    },
    {
        key: "business_code_4",
        name: "事業者コード",
        editable: false
    },
    {
        key: "business_name_4",
        name: "事業者名",
        editable: false
    },
    {
        key: "data_name_4",
        name: "データ名称",
        editable: false
    },
    {
        key: "asset_type",
        name: "資産の種類等",
        editable: false
    },
    {
        key: "business_code_5",
        name: "事業者コード",
        editable: false
    },
    {
        key: "business_name_5",
        name: "事業者名",
        editable: false
    },
    {
        key: "data_name_5",
        name: "データ名称",
        editable: false
    },
    {
        key: "supplier_name",
        name: "取引先の氏名_名称",
        editable: false
    },
    {
        key: "business_code_6",
        name: "事業者コード",
        editable: false
    },
    {
        key: "business_name_6",
        name: "事業者名",
        editable: false
    },
    {
        key: "data_name_6",
        name: "データ名称",
        editable: false
    },
    {
        key: "item_name_6",
        name: "項目名",
        editable: false
    },
    {
        key: "settlement_method_category",
        name: "決算額_経理方式区分",
        editable: false
    },
    {
        key: "profit_item_a",
        name: "損益科目_商品仕入高等_イ_千円",
        editable: false
    },
    {
        key: "profit_item_b",
        name: "損益科目_商品仕入高等_ロ_千円",
        editable: false
    },
    {
        key: "profit_amount_common_a",
        name: "損益科目_販売費_一般管理費_イ_千円",
        editable: false
    },
    {
        key: "profit_amount_common_b",
        name: "損益科目_販売費_一般管理費_ロ_千円",
        editable: false
    },
    {
        key: "profit_expense_a",
        name: "損益科目_営業外費用_イ_千円",
        editable: false
    },
    {
        key: "profit_expense_b",
        name: "損益科目_営業外費用_ロ_千円",
        editable: false
    },
    {
        key: "profit_other_a",
        name: "損益科目_その他_イ_千円",
        editable: false
    },
    {
        key: "profit_other_b",
        name: "損益科目_その他_ロ_千円",
        editable: false
    },
    {
        key: "asset_acquisition_category",
        name: "資産の取得価額_経理方式区分",
        editable: false
    },
    {
        key: "asset_fixed_a",
        name: "資産科目_固定資産_イ_千円",
        editable: false
    },
    {
        key: "asset_fixed_b",
        name: "資産科目_固定資産_ロ_千円",
        editable: false
    },
    {
        key: "asset_deferred_a",
        name: "資産科目_繰延資産_イ_千円",
        editable: false
    },
    {
        key: "asset_deferred_b",
        name: "資産科目_繰延資産_ロ_千円",
        editable: false
    },
    {
        key: "asset_other_a",
        name: "資産科目_その他_イ_千円",
        editable: false
    },
    {
        key: "asset_other_b",
        name: "資産科目_その他_ロ_千円",
        editable: false
    },
    {
        key: "total_taxable_amount",
        name: "課税仕入れ等の税額の合計額_千円",
        editable: false
    },
    {
        key: "inventory_amount_category",
        name: "棚卸資産_原材料等_取引金額等_経理方式区分",
        editable: false
    },
    {
        key: "fixed_asset_method_category",
        name: "固定資産等_取引金額等_経理方式区分",
        editable: false
    },
    {
        key: "special_1",
        name: "特殊事情_1段",
        editable: false
    },
    {
        key: "special_2",
        name: "特殊事情_2段",
        editable: false
    },
    {
        key: "special_3",
        name: "特殊事情_3段",
        editable: false
    },
    {
        key: "special_4",
        name: "特殊事情_4段",
        editable: false
    },
    {
        key: "business_code_7",
        name: "事業者コード",
        editable: false
    },
    {
        key: "business_name_7",
        name: "事業者名",
        editable: false
    },
    {
        key: "data_name_7",
        name: "データ名称",
        editable: false
    },
    {
        key: "asset_type_2",
        name: "資産の種類等",
        editable: false
    },
    {
        key: "continuation_category",
        name: "取得年月日等_継続区分",
        editable: false
    },
    {
        key: "acquisition_date",
        name: "取得年月日等_取得年月日",
        editable: false
    },
    {
        key: "transaction_amount",
        name: "取引金額等_千円",
        editable: false
    },
    {
        key: "supplier_name_2",
        name: "取引先の氏名_名称",
        editable: false
    },
    {
        key: "supplier_address",
        name: "取引先の住所_所在地_下段",
        editable: false
    },
    {
        key: "business_code_8",
        name: "事業者コード",
        editable: false
    },
    {
        key: "business_name_8",
        name: "事業者名",
        editable: false
    },
    {
        key: "data_name_8",
        name: "データ名称",
        editable: false
    },
    {
        key: "asset_type_3",
        name: "資産の種類等",
        editable: false
    }
];

export { tabledeclaration };
